var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469",
      opacity: 0
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F",
      opacity: 0
    },
    d: "M39.8,390.5C85,461.1,164,508,254,508s169-46.9,214.2-117.5H39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M422.7,360.6H85.3c-1.3,0-2.4-1.1-2.4-2.4V120.1c0-1.3,1.1-2.4,2.4-2.4h337.3c1.3,0,2.4,1.1,2.4,2.4 v238.1C425.1,359.5,424,360.6,422.7,360.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.1,
    y: 141.5,
    style: {
      fill: "#84DBFF"
    },
    width: 317.8,
    height: 198.3
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B3B4E"
    },
    cx: 254,
    cy: 129.4,
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M416.2,390.3H91.8c-16.4,0-29.7-13.3-29.7-29.7l0,0h383.8l0,0C445.9,377,432.6,390.3,416.2,390.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CED5E0"
    },
    points: "298.8,360.6 209.2,360.6 216.8,371.2 291.2,371.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.7,165.7H165.3c-6.6,0-12,5.4-12,12v98.9c0,6.6,5.4,12,12,12h14.9l32.1,26.4l-4.4-26.4h134.9 c6.6,0,12-5.4,12-12v-98.9C354.7,171.1,349.3,165.7,342.7,165.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M200.2,213.8c1.1-1.6,1.7-3.1,1.7-4.6s-0.5-2.7-1.5-3.7s-2.2-1.5-3.7-1.5c-2.8,0-5.4,2-7.9,5.9 l-7.9-4.7c2.1-3.2,4.3-5.6,6.8-7.3c2.5-1.6,5.6-2.5,9.4-2.5s7.2,1.2,10.1,3.6c2.9,2.4,4.3,5.7,4.3,9.9c0,2.3-0.6,4.5-1.7,6.5 c-1.2,2.1-3.3,4.8-6.4,8l-8,8.3h17.5v8.9h-31.2v-7.3l13-13.3C197.2,217.5,199.1,215.4,200.2,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M236.3,221.7V214h9.5v7.7h5v8.5h-5v10.6h-9.5v-10.6h-17.8v-7.5l15.7-26.1H245l-15,25.1H236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M281.6,189.9h9l-26.6,58h-8.9L281.6,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M295.2,210.8v-14.2h31.9v7.5l-17.9,36.7h-10.7l17.1-35.7h-11.1v5.7H295.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.ff37bda8f550b72fcf823f7f0fd2a672.svg";
export { ForwardRef as ReactComponent };